import React, { FC } from 'react';

import { Field, Form } from 'react-final-form';
import { composeValidators, isPhoneNumber, isRequired } from '../../../shared';
import styles from './feedbackForm.module.scss';
import { useTranslation } from 'react-i18next';

export interface IFeedbackForm {
  onSubmit: (values: any) => Promise<void>;
}
export const FeedbackForm: FC<IFeedbackForm> = ({ onSubmit }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.form_wrap}>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form onSubmit={handleSubmit}>
            <div className={styles.top_part}>
              <Field name="name" validate={isRequired}>
                {({ input, meta }) => (
                  <div
                    className={
                      meta.error && meta.touched ? styles.form_input_error : ''
                    }
                  >
                    <input
                      {...input}
                      type="text"
                      placeholder={t('entriesForms.firstNamePlaceholder')}
                    />
                    {meta.error && meta.touched && <span>{t(meta.error)}</span>}
                  </div>
                )}
              </Field>
              <Field
                name="phoneNumber"
                validate={composeValidators(isRequired, isPhoneNumber)}
              >
                {({ input, meta }) => {
                  return (
                    <div
                      className={
                        meta.error && meta.touched
                          ? styles.form_input_error
                          : ''
                      }
                    >
                      <input
                        {...input}
                        type="tel"
                        value={values.phoneNumber}
                        onFocus={(e) => {
                          if (e.target.value === '') {
                            e.target.value = '+';
                          }
                        }}
                        placeholder={t('entriesForms.phonePlaceholder')}
                      />
                      {meta.error && meta.touched && (
                        <span>{t(meta.error)}</span>
                      )}
                    </div>
                  );
                }}
              </Field>
              <Field type="email" name="email">
                {({ input, meta }) => (
                  <div
                    className={
                      meta.error && meta.touched ? styles.form_input_error : ''
                    }
                  >
                    <input
                      {...input}
                      type="text"
                      placeholder={t('entriesForms.emailPlaceholder')}
                    />
                  </div>
                )}
              </Field>
            </div>
            <div className={styles.message}>
              <Field
                name="message"
                component="textarea"
                placeholder={t('entriesForms.messagePlaceholder')}
              />
            </div>
            <div className={styles.buttom_wrap}>
              <button
                type="submit"
                className={`${styles.form_button} ${
                  submitting && styles.disabled
                }`}
                disabled={submitting}
              >
                {t('buttons.send')}
              </button>
            </div>
          </form>
        )}
      />
      <p className={styles.youWillBeContacted}>{t('youWillBeContacted')}</p>
    </div>
  );
};
